import { Action } from '@ngrx/store';
import { RecipeFormValues } from '../../retail-specification/models/form-values';
import { KeyValues } from '../../specification/models/specification-form-values';
import { RmsFormConfig } from '../models/rms-form-config';
import { VolumeAllocationValidation } from '@ordersnproducts/modules/order-builder/models/volume-allocation-validation.model';
import { CustomerVolumeRequestValidation } from '@cemex-core/cmx-api/models/customer-volume-management/customer-volume-validation-request';

export enum RmsSpecificationActionTypes {
  INIT = '[Rms Specification] Init',
  RESET = '[Rms Specification] Reset',
  ADD_ITEM = '[Rms Specification] Add recipe item',
  UPDATE_ITEM = '[Rms Specification] Update recipe item',
  UPDATE_ITEM_PARTIAL_ITEM = '[Rms Specification] Update recipe item relative item',
  RESET_UPDATE_FORM = '[Rms Specification] reset update form',
  SET_ITEMS_SEQ_NUM = '[Rms Specification] Set items seq num',
  RESET_ITEMS_SEQ_NUM = '[Rms Specification] Reset items seq num',
  REMOVE_ITEM = '[Rms Specification] Remove recipe item',
  SET_FORM_READY = '[Rms Specification] Set form ready',
  SET_INDIVIDUAL_FORM_READY = '[RMS Specification] Set individual form ready',
  SET_REHYDRATE = '[Rms Specification] Set rehydrate item',
  REMOVE_REHYDRATE = '[Rms Specification] Remove rehydrate item',
  LOAD_RECIPES = '[Rms Specification] Load repeat recipes',
  LOAD_RECIPES_MODIFY = '[Rms Specification] Load modify recipes',
  SET_RAW_MATERIAL = '[Rms Specification] Set raw material restriction',
  GET_VOLUME_MANAGEMENT = '[Rms Specification] Get volume management',
  GET_VOLUME_MANAGEMENT_SUCCESS = '[Rms Specification] Get volume management success',
  RESET_VOLUME_MANAGEMENT = '[Rms Specification] Reset Volume Management',
  GET_VOLUME_MANAGEMENT_ERROR = '[Rms Specification] Get volume management error',
  LOADING_VOLUME_MANAGEMENT = '[Rms Specification] Get volume management loading',
  REMOVE_ALL_ITEMS_EXCEPT = '[Rms Specification] Remove all recipe items except one of id payload',
}

export class RmsSpecificationLoadAction implements Action {
  readonly type = RmsSpecificationActionTypes.INIT;

  constructor(public payload: RmsFormConfig) {}
}

export class RmsSpecificationAddItemAction implements Action {
  readonly type = RmsSpecificationActionTypes.ADD_ITEM;

  constructor(public payload?: { [key: string]: any }) {}
}

export class RmsSpecificationUpdateItemAction implements Action {
  readonly type = RmsSpecificationActionTypes.UPDATE_ITEM;

  constructor(public payload: RecipeFormValues) {}
}
export class RmsSpecificationResetUpdateFormAction implements Action {
  readonly type = RmsSpecificationActionTypes.RESET_UPDATE_FORM;

  constructor() {}
}

export class RmsSpecificationSetItemsSeqAction implements Action {
  readonly type = RmsSpecificationActionTypes.SET_ITEMS_SEQ_NUM;

  constructor() {}
}

export class RmsSpecificationResetItemsSeqAction implements Action {
  readonly type = RmsSpecificationActionTypes.RESET_ITEMS_SEQ_NUM;

  constructor() {}
}

export class RmsSpecificationRemoveItemAction implements Action {
  readonly type = RmsSpecificationActionTypes.REMOVE_ITEM;

  constructor(public payload: number) {}
}

export class RmsSpecificationSetFormReadyAction implements Action {
  readonly type = RmsSpecificationActionTypes.SET_FORM_READY;

  constructor(public payload: boolean) {}
}

export class RmsSpecificationSetIndividualFormReady implements Action {
  readonly type = RmsSpecificationActionTypes.SET_INDIVIDUAL_FORM_READY;
  constructor(public payload: { isReady: boolean; formIndex: number }) {}
}

export class RmsSpecificationSetRehydrate implements Action {
  readonly type = RmsSpecificationActionTypes.SET_REHYDRATE;

  constructor(public payload: { [id: number]: { [key: string]: any } }) {}
}

export class RmsSpecificationRemoveRehydrateItem implements Action {
  readonly type = RmsSpecificationActionTypes.REMOVE_REHYDRATE;

  constructor(public payload: { id: number; key: string }) {}
}

export class RmsSpecificationResetAction implements Action {
  readonly type = RmsSpecificationActionTypes.RESET;

  constructor() {}
}
export class RmsSpecificationLoadRecipesAction implements Action {
  readonly type = RmsSpecificationActionTypes.LOAD_RECIPES;

  constructor(public payload: KeyValues[]) {}
}
export class RmsSpecificationLoadRecipesModifyAction implements Action {
  readonly type = RmsSpecificationActionTypes.LOAD_RECIPES_MODIFY;

  constructor(public payload: KeyValues[]) {}
}

export class RmsSpecificationSetRawMaterialAction implements Action {
  readonly type = RmsSpecificationActionTypes.SET_RAW_MATERIAL;

  constructor(public payload: boolean) {}
}

export class RmsSpecificationGetVolumeManagement implements Action {
  readonly type = RmsSpecificationActionTypes.GET_VOLUME_MANAGEMENT;
  constructor(public payload: CustomerVolumeRequestValidation) {}
}
export class RmsSpecificationGetVolumeManagementSuccess implements Action {
  readonly type = RmsSpecificationActionTypes.GET_VOLUME_MANAGEMENT_SUCCESS;
  constructor(public payload: VolumeAllocationValidation) {}
}
export class RmsSpecificationGetVolumeManagementError implements Action {
  readonly type = RmsSpecificationActionTypes.GET_VOLUME_MANAGEMENT_ERROR;
  constructor() {}
}
export class RmsSpecificationGetVolumeManagementLoading implements Action {
  readonly type = RmsSpecificationActionTypes.LOADING_VOLUME_MANAGEMENT;
  constructor() {}
}

export class RmsSpecificationResetVolumeManagement implements Action {
  readonly type = RmsSpecificationActionTypes.RESET_VOLUME_MANAGEMENT;
  constructor() {}
}

/**
 * Remove all receipt forms except the one with id payload
 */
export class RmsRemoveAllReceiptFormsExcept implements Action {
  readonly type = RmsSpecificationActionTypes.REMOVE_ALL_ITEMS_EXCEPT;
  constructor(public payload: number) {}
}

/**
 * Action class to update a partial item in the RMS specification.
 *
 * @implements {Action}
 *
 * @property {string} type - The type of the action.
 * @property {RecipeFormValues} payload - The payload containing the recipe form values to update.
 *
 * @param {RecipeFormValues} payload - The payload containing the recipe form values to update.
 */
export class RmsSpecificationUpdatePartialItemAction implements Action {
  readonly type = RmsSpecificationActionTypes.UPDATE_ITEM_PARTIAL_ITEM;

  constructor(public payload: RecipeFormValues) {}
}

export type RmsSpecificationActions =
  | RmsSpecificationLoadAction
  | RmsSpecificationAddItemAction
  | RmsSpecificationUpdateItemAction
  | RmsSpecificationSetItemsSeqAction
  | RmsSpecificationResetItemsSeqAction
  | RmsSpecificationRemoveItemAction
  | RmsSpecificationSetFormReadyAction
  | RmsSpecificationSetIndividualFormReady
  | RmsSpecificationSetRehydrate
  | RmsSpecificationRemoveRehydrateItem
  | RmsSpecificationLoadRecipesModifyAction
  | RmsSpecificationResetAction
  | RmsSpecificationLoadRecipesAction
  | RmsSpecificationResetUpdateFormAction
  | RmsSpecificationSetRawMaterialAction
  | RmsSpecificationGetVolumeManagement
  | RmsSpecificationGetVolumeManagementSuccess
  | RmsSpecificationGetVolumeManagementError
  | RmsSpecificationGetVolumeManagementLoading
  | RmsSpecificationResetVolumeManagement
  | RmsRemoveAllReceiptFormsExcept
  | RmsSpecificationUpdatePartialItemAction;
